import { createContext, useContext, useState } from "react";
import BookingModal from "@/components/BookingModal";
import { track } from "@/lib/api";

const BookingContext = createContext({ open: () => {} });

export const BookingProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = (source) => { if (source) track("book_click", source); setIsOpen(true); };
  return (
    <BookingContext.Provider value={{ open }}>
      {children}
      <BookingModal open={isOpen} onOpenChange={setIsOpen} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
